
/**
 * Default role assigned to users when no specific role is found
 */
export const DEFAULT_ROLE = 'USER';

/**
 * Role hierarchy from lowest to highest permissions
 */
export const ROLE_HIERARCHY = ['USER', 'DEALER', 'ADMIN', 'SUPER_ADMIN'];

/**
 * TTL for role cache in milliseconds (30 minutes)
 */
export const ROLE_CACHE_TTL = 30 * 60 * 1000;

/**
 * Check if a role has permission for a required role
 * @param userRole User's current role
 * @param requiredRole Role required for an operation
 * @returns True if user has sufficient permissions
 */
export const hasRolePermission = (userRole: string, requiredRole: string): boolean => {
  if (!userRole || !requiredRole) return false;
  
  const userRoleUppercase = userRole.toUpperCase();
  const requiredRoleUppercase = requiredRole.toUpperCase();
  
  const userRoleIndex = ROLE_HIERARCHY.indexOf(userRoleUppercase);
  const requiredRoleIndex = ROLE_HIERARCHY.indexOf(requiredRoleUppercase);
  
  // If either role is not found in hierarchy, default behavior
  if (userRoleIndex === -1 || requiredRoleIndex === -1) {
    return userRoleUppercase === requiredRoleUppercase;
  }
  
  // User has permission if their role is higher or equal in hierarchy
  return userRoleIndex >= requiredRoleIndex;
};

/**
 * Alias for hasRolePermission for backward compatibility
 */
export const hasRolePrivilege = hasRolePermission;
